import { VCard } from 'vuetify/lib/components/VCard';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{staticClass:"ma-4 pa-3 text-center",attrs:{"color":_vm.color},on:{"click":function($event){_vm.action !== null ? _vm.action : null}}},[_c('h2',{staticClass:"white--text"},[_vm._v(_vm._s(_vm.title)),_c('br'),_vm._v(" "),(_vm.value)?_c('span',[_vm._v(_vm._s(_vm.value))]):_c('span',[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }